import { cellToParent } from "h3-js"

import { LandH3Cell } from "../coverage_land/uk/data"
import { SUBURBAN_DEMAND_MULTIPLIER, URBAN_DEMAND_MULTIPLIER } from "./relative_demand"


export function get_initial_proportional_demand_by_h3r4_cell(h3r5_land_cells: LandH3Cell[]): Record<string, number>
{
    const proportional_demand_by_h3r4: Record<string, number> = {}
    let total_h5_cells = 0

    h3r5_land_cells.forEach(cell =>
    {
        if (cell.type !== "suburban" && cell.type !== "urban") return
        total_h5_cells++
        const h3_res5_id = cell.h3h5_id
        const h3r4_id = cellToParent(h3_res5_id, 4)

        let entry: number = proportional_demand_by_h3r4[h3r4_id] || 0

        // TODO: Correct for varying area of H3Geo's cells
        entry += cell.type === "suburban" ? SUBURBAN_DEMAND_MULTIPLIER : URBAN_DEMAND_MULTIPLIER
        proportional_demand_by_h3r4[h3r4_id] = entry
    })

    Object.entries(proportional_demand_by_h3r4).forEach(([h3r4, proportional_demand]) =>
    {
        proportional_demand_by_h3r4[h3r4] = proportional_demand / total_h5_cells
    })

    return proportional_demand_by_h3r4
}
